import React from "react";
import axios from "axios";
import Form from "react-validation/build/form";

import { BACKEND_CONFIG } from "../../config/consts";
import { ValidationProvider } from "../../validation/validation-provider";
import Input from "../../components/Input";
import { required, email } from "../../validation/validation";
import PasswordInput from "../../components/PasswordInput";

import ChangePasswordConfirm from "./ChangePasswordConfirm";
import ResetPasswordLinkExpired from "./ResetPasswordLinkExpired";

export default class ChangePassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      emailAddress: "",
      password: "",
      passwordConfirm: "",
      isValid: false,
      isTokenValid: false,
      generalValidationMessage: "",
    };

    this.formRef = React.createRef();
  }

  UNSAFE_componentWillMount() {
    const validateTokenUrl = `${BACKEND_CONFIG.apiUrl}account/reset-password/validate?token=${this.props.match.params.token}`;

    axios
      .get(validateTokenUrl)
      .then((result) => {
        this.setState({
          isTokenValid: result.data.Valid,
          emailAddress: result.data.EmailAddress,
        });
      })
      .catch(() => {
        this.setState({
          isTokenValid: false,
        });
      });
  }

  onHandleSubmit(event) {
    let isValid = ValidationProvider.isValid(this.formRef);

    if (!isValid) {
      this.setState({ isPaymentMethodValid: false });
      return;
    }

    const { emailAddress, password, passwordConfirm } = this.state;
    const resetUrl = `${BACKEND_CONFIG.apiUrl}/account/change-password`;

    axios
      .post(resetUrl, { emailAddress, password, passwordConfirm })
      .then((result) =>
        this.setState({
          isValid: result.data.Valid,
        })
      )
      .catch((error) => {
        let errorResponse = error.response;

        if (errorResponse.data.Message) {
          this.setState({
            generalValidationMessage: errorResponse.data.Message,
          });
        }

        this.props.onServerValidationErrors(
          error.response.data.ValidationErrors
        );
      });

    event.preventDefault();
  }

  updateData = (e) => {
    const field = e.target.name;
    this.setState({ [field]: e.target.value });
  };

  render() {
    const { isValid, isTokenValid } = this.state;

    return (
      <div className="component reset-password-page">
        {isValid ? (
          <ChangePasswordConfirm />
        ) : isTokenValid ? (
          <div>
            <div className="background-wrapper creamy-cement" />
            <h2>Reset Password</h2>
            <div className="center-box">
              <p>Password must:</p>
              <ul>
                <li>Be 6-10 characters long</li>
                <li>
                  Contain capital letters, lowercase letters, numbers and/or
                  special characters.
                </li>
                <li>Have NO spaces</li>
                <li>Have NO '\' or '/' characters</li>
              </ul>

              <Form ref={this.formRef}>
                <div className="form-group label-static w-100">
                  <label htmlFor="email">Email Address</label>
                  <Input
                    value={this.state.emailAddress}
                    defaultValue={this.state.emailAddress}
                    type="email"
                    id="emailAddress"
                    name="emailAddress"
                    onBlur={this.updateData}
                    readOnly
                    placeholder="Email"
                    field="emailAddress"
                    validations={[required, email]}
                  />
                </div>
                <div className="form-group label-static w-100">
                  <label htmlFor="password">Enter New Password</label>
                  <PasswordInput
                    value={this.state.password}
                    type="password"
                    id="password"
                    name="password"
                    placeholder="Password"
                    onBlur={this.updateData}
                    validations={[required]}
                    field="password"
                  />
                </div>
                <div className="form-group label-static w-100">
                  <label htmlFor="passwordConfirm">Confirm Password</label>
                  <PasswordInput
                    value={this.state.passwordConfirm}
                    type="password"
                    id="passwordConfirm"
                    name="passwordConfirm"
                    placeholder="Confirm Password"
                    onBlur={this.updateData}
                    validations={[required]}
                    field="passwordConfirm"
                  />
                </div>
                <div className="form-group label-static w-100">
                  {this.state.generalValidationMessage && (
                    <span className="error-message is-visible">
                      {this.state.generalValidationMessage}
                    </span>
                  )}
                </div>
              </Form>
              <button
                className="btn btn-primary w-100 mt-1"
                onClick={(event) => this.onHandleSubmit(event)}
              >
                Submit
              </button>
            </div>
          </div>
        ) : (
          <ResetPasswordLinkExpired />
        )}
      </div>
    );
  }
}
